import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async atualizarManifesto(api, parametros) {

    let retorno = {};
    parametros.operacao = 'atualizarManifesto';

    await api.santriPOST('/rest/manifesto', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
  
  async buscarManifesto(api, parametros) {       

    let retorno = {};    

    await api.santriGET('/rest/manifesto', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },  
  
  async buscarManifestoCompleto(api, parametros) {       

    let retorno = {};

    await api.santriGET('/rest/manifesto', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
  
  async buscarMotivosRetorno(api) {   
    let parametros = {operacao: 'buscarMotivosRetorno'};

    let retorno = {};

    await api.santriGET('/rest/manifesto', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async verificarEntregaConfirmada(api, parametros) {       
    parametros.operacao = 'verificarEntregaConfirmada';

    let retorno = {};

    await api.santriGET('/rest/manifesto', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
  
}


// WEBPACK FOOTER //
// ./src/components/Rest/RManifesto.js